import { css } from '@fable/theme'
import { SectionBlur } from './variants'
import { useStatsTheme } from '../../ctx'
import { StatsSectionType } from '../../types'

interface Props {
  type: StatsSectionType
}

export const StatsThemeSectionBlurs = ({ type }: Props) => {
  const theme = useStatsTheme((s) => s.theme)
  const colors = theme.colors.blurs

  const getBlurs = () => {
    switch (type) {
      case 'hero':
        return null
      case 'section':
        return <SectionBlur {...colors.section} />
      case 'sectionAlt':
        return <SectionBlur {...colors.sectionAlt} />
    }
  }

  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: ${theme.id.includes('dark') ? 0 : 1};
        transition: opacity 0.3s ease-in-out;
      `}
    >
      {getBlurs()}
    </div>
  )
}
